import { CtaBand } from "@/components/marketplace"
import type { CtaBandSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const CtaBandFeedSection = ({ section, context }: FeedSectionProps<CtaBandSection>) => {
  const { eyebrow, title, accent, sub, chips, cta, image } = section.data
  return (
    <SectionFrame section={section} context={context} gut>
      <CtaBand
        variant={section.presentation.variant}
        image={image?.url}
        imageTall={image?.urlTall}
        imageAlt={image?.alt}
        eyebrow={eyebrow}
        title={title}
        accent={accent}
        sub={sub}
        chips={chips}
        cta={cta?.label}
        ctaHref={cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined}
      />
    </SectionFrame>
  )
}
